// extracted by mini-css-extract-plugin
export default {"horizontal-container":"HorizantalLine_horizontal-container__ochVB","horizontal":"HorizantalLine_horizontal__hQdQO"};